﻿import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';

import {registerVirtualPageViewAction} from '../State/actions';

import Accordion from '../../../UI/Accordion';
import HealthDeclarationHeading from './HealthDeclarationHeading';

import definitions from '../../../Style/LfStyleDefinitions';
import { iconCode, mediaQuery, clearFix } from '../../../Style/cssHelpers';

class HealthDeclarationStepThree extends React.Component {
    componentDidMount() {
        this.props.registerVirtualPageView();
    }

    render() {
        const HealthDeclarationSavedStatus = () => {
            const healthDeclarationStatus = this.props.saveStatus.status;

            return (
                <HealthDeclarationSavedStatusWrapper>
                    {status[healthDeclarationStatus]}
                </HealthDeclarationSavedStatusWrapper>
            );
        }

        return (
            <div>
                <Accordion
                    title={<HealthDeclarationHeading/>}
                    unexpandable={true}
                    noHeaderPadding={true}
                    headerComponent={<HealthDeclarationSavedStatus/>}
                />
            </div>
        );
    }
}

const status = {
    success: 'Din hälsoprövning är godkänd och försäkringen har tecknats.',
    processing: 'Tack för din ansökan. Köpet är under behandling och kommer att slutföras inom kort. När försäkringen är godkänd ser du den under "Mina försäkringar". Om du inte ser försäkringen kontakta kundservice på 0771-21 09 09.',
    risk: 'Tack för din ansökan. Din hälsoprövning är skickad för granskning och vi återkommer med besked inom kort.',
    failed: 'Ett fel uppstod när hälsodeklarationen skulle skickas in. Vänligen försök på nytt och kontakta kundservice om problemet kvarstår.'
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.healthDeclarationPageAnswers,
        saveStatus: state.healthDeclarationSavedResult
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        registerVirtualPageView: () => dispatch(registerVirtualPageViewAction())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthDeclarationStepThree);

// styles

export const HealthDeclarationSavedStatusWrapper = styled.div`
    background-color: white;
    color: black;
    padding: 30px;
    font-family: ${definitions.fonts.main};
    font-size: 18px;

    ${mediaQuery.medium(`
        padding: 25px;
        font-size: 16px;
    `)}

    ${mediaQuery.small(`
        padding: 20px;
    `)}
`;
